export interface IClientFilter{
  searchedText: string,
  searchedTextParent: string,
  isReceiver: string,
  createAdhesion: boolean;
}

export let emptyClientFilter: IClientFilter = {
  searchedText: '',
  searchedTextParent: '',
  isReceiver: '',
  createAdhesion: false
};




// WEBPACK FOOTER //
// ./src/app/model/client-filter.ts